<button type="button" class="btn btn-primary"
        popover="Vivamus sagittis lacus vel augue laoreet rutrum faucibus." [delay]="500">
  Popover with 0.5sec delay
</button>

